import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { postValidateRecaptcha } from "../api/apimethods";
import { ICaptchaRequest } from "../typings/interfaces/Requests/CaptchaRequest";
import { notify } from "../utils/Notify";
import { NotifyType } from "../utils/app-config";
import { setRecaptchaRef as setApiRecaptchaRef } from "../api/builder";

// Store the reCAPTCHA ref for the legacy axios interceptor.
let recaptchaRef: React.RefObject<ReCAPTCHA> | null = null;

export function setRecaptchaRef(ref: React.RefObject<ReCAPTCHA>) {
  setApiRecaptchaRef(ref);
  recaptchaRef = ref;
}

// Axios request interceptor
axios.interceptors.request.use(
  async (config) => {
    const isPost = config.method?.toLowerCase() === "post";
  const isIgnored = config.url?.includes("/recaptcha/verify") 
  ||  config.url?.includes("/forget-password")
  ||  config.url?.includes("/reset-password")
  ||  config.url?.includes("/harvest-microchipregistration")
  || config.url?.includes("/application-registration");

  // ✅ Skip for non-POSTs or ignored URLs
  if (!isPost || !isIgnored) return config;

    if (!recaptchaRef || !recaptchaRef.current) {
      // reCAPTCHA ref not available yet — surface a UI error and cancel.
      notify().message(NotifyType.Error, "Please complete the reCAPTCHA verification.");
      throw new axios.Cancel("reCAPTCHA ref missing — request cancelled.");
    }

    // Get token from reCAPTCHA (may be null/empty if user hasn't completed it)
    const token = recaptchaRef.current?.getValue();

    if (!token) {
      // Inform user and cancel the request so server isn't called without a token
      notify().message(NotifyType.Error, "Please complete the reCAPTCHA verification.");
      throw new axios.Cancel("reCAPTCHA token missing — request cancelled.");
    }

    // Attach token header for server-side verification
    config.headers = config.headers ?? {};
    config.headers["X-Recaptcha-token"] = token;

    return config;
  },
  (error) => {
    // Any setup error
    return Promise.reject(error);
  }
);
